import { EditOutlined } from '@ant-design/icons';
import { App, Typography } from 'antd';
import { ActionsDropdown } from '@/shared/components/ActionsDropdown';
import { useDeleteRuleGroup, useRestoreRuleGroup } from '@/features/agreements/hooks/useRuleGroups';
import { getErrorMessage } from '@/shared/utils/errors/getErrorMessage';
import { getToggleActiveMenuItem } from '@/shared/utils/menuItems/getToggleActiveMenuItem';

const { Text } = Typography;

export const RuleGroupActionsDropdown = ({ ruleGroup, onChange, onEdit }) => {
  const { notification, modal } = App.useApp();

  const deleteRuleGroupMutation = useDeleteRuleGroup();
  const restoreRuleGroupMutation = useRestoreRuleGroup();

  const handleActivateRuleGroup = () => {
    restoreRuleGroupMutation.mutate({ id: ruleGroup.id }, {
      onSuccess: () => {
        // Llamar onChange para notificar al componente padre del cambio
        onChange?.();
        notification.success({
          message: <Text strong>Grupo de condiciones activado</Text>,
          description: '¡El grupo de condiciones se ha activado correctamente!',
        });
      },
      onError: (error) => {
        notification.error({
          message: <Text strong>Grupo de condiciones no activado</Text>,
          description: getErrorMessage(error),
        });
      },
    });
  };

  const handleInactivateRuleGroup = () => {
    modal.confirm({
      title: '¿Seguro que deseas inactivar el grupo de condiciones?',
      content: (
        <Text>
          El grupo de condiciones dejará de aplicarse en el proceso de evaluación correspondiente.
          Podrás activarlo más adelante si deseas que vuelva a considerarse.
        </Text>
      ),
      okText: 'Sí, inactivar',
      onOk: () => {
        deleteRuleGroupMutation.mutate({ id: ruleGroup.id }, {
          onSuccess: () => {
            // Llamar onChange para notificar al componente padre del cambio
            onChange?.();
            notification.success({
              message: <Text strong>Grupo de condiciones inactivado</Text>,
              description: '¡El grupo de condiciones se ha inactivado correctamente!',
            });
          },
          onError: (error) => {
            notification.error({
              message: <Text strong>Grupo de condiciones no inactivado</Text>,
              description: getErrorMessage(error),
            });
          },
        });
      },
    });
  };

  const actions = {
    activate: {
      handler: handleActivateRuleGroup,
      loading: restoreRuleGroupMutation.isPending,
    },
    inactivate: {
      handler: handleInactivateRuleGroup,
      loading: deleteRuleGroupMutation.isPending,
    },
  };

  const menuItems = [
    ...(onEdit ? [{
      key: 'edit',
      label: 'Editar',
      icon: <EditOutlined />,
      onClick: () => onEdit(ruleGroup),
    }] : []),
    getToggleActiveMenuItem({
      record: ruleGroup,
      onActivate: actions.activate.handler,
      onInactivate: actions.inactivate.handler,
      loading: actions.activate.loading || actions.inactivate.loading,
    }),
  ];

  return <ActionsDropdown items={menuItems} />;
};
